// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json = require("../Json.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var TypeUtils = require("./TypeUtils.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");

function fromEnum(param) {
  return param + 1 | 0;
}

function toEnum(param) {
  switch (param) {
    case 1 :
        return /* OneStar */0;
    case 2 :
        return /* TwoStars */1;
    case 3 :
        return /* ThreeStars */2;
    case 4 :
        return /* FourStars */3;
    case 5 :
        return /* FiveStars */4;
    default:
      return ;
  }
}

var include = TypeUtils.TypeClasses.WithGenerateable({
      startingIndex: 1,
      fromEnum: fromEnum,
      toEnum: toEnum
    });

var fromEnum$1 = include.fromEnum;

var toEnum$1 = include.toEnum;

function toString(param) {
  switch (param) {
    case /* OneStar */0 :
        return "1 Star";
    case /* TwoStars */1 :
        return "2 Stars";
    case /* ThreeStars */2 :
        return "3 Stars";
    case /* FourStars */3 :
        return "4 Stars";
    case /* FiveStars */4 :
        return "5 Stars";
    
  }
}

function fromString(param) {
  switch (param) {
    case "1 Star" :
        return /* OneStar */0;
    case "2 Stars" :
        return /* TwoStars */1;
    case "3 Stars" :
        return /* ThreeStars */2;
    case "4 Stars" :
        return /* FourStars */3;
    case "5 Stars" :
        return /* FiveStars */4;
    default:
      return ;
  }
}

function fromInt(param) {
  switch (param) {
    case 1 :
        return /* OneStar */0;
    case 2 :
        return /* TwoStars */1;
    case 3 :
        return /* ThreeStars */2;
    case 4 :
        return /* FourStars */3;
    case 5 :
        return /* FiveStars */4;
    default:
      return ;
  }
}

var decode = Curry._1(Json.Decode.variantFromInt, toEnum$1);

function encode(param) {
  return Relude_Globals.$great$great(fromEnum$1, (function (prim) {
                return prim;
              }), param);
}

var eq = include.eq;

var compare = include.compare;

var Ord = include.Ord;

var compareWithConversion = include.compareWithConversion;

var compareReversed = include.compareReversed;

var OrdReversed = include.OrdReversed;

var compareAsInt = include.compareAsInt;

var min = include.min;

var max = include.max;

var lessThan = include.lessThan;

var lt = include.lt;

var lessThanOrEq = include.lessThanOrEq;

var lte = include.lte;

var greaterThan = include.greaterThan;

var gt = include.gt;

var greaterThanOrEq = include.greaterThanOrEq;

var gte = include.gte;

var clamp = include.clamp;

var between = include.between;

var OrdRingExtensions = include.OrdRingExtensions;

var OrdNamed = include.OrdNamed;

var OrdBy = include.OrdBy;

var $$Set = include.$$Set;

var SetWithNone = include.SetWithNone;

var $$Map = include.$$Map;

var list = include.list;

var array = include.array;

var set = include.set;

var setWithNone = include.setWithNone;

var cardinality = include.cardinality;

var top = include.top;

var bottom = include.bottom;

var succ = include.succ;

var pred = include.pred;

exports.fromEnum = fromEnum$1;
exports.toEnum = toEnum$1;
exports.eq = eq;
exports.compare = compare;
exports.Ord = Ord;
exports.compareWithConversion = compareWithConversion;
exports.compareReversed = compareReversed;
exports.OrdReversed = OrdReversed;
exports.compareAsInt = compareAsInt;
exports.min = min;
exports.max = max;
exports.lessThan = lessThan;
exports.lt = lt;
exports.lessThanOrEq = lessThanOrEq;
exports.lte = lte;
exports.greaterThan = greaterThan;
exports.gt = gt;
exports.greaterThanOrEq = greaterThanOrEq;
exports.gte = gte;
exports.clamp = clamp;
exports.between = between;
exports.OrdRingExtensions = OrdRingExtensions;
exports.OrdNamed = OrdNamed;
exports.OrdBy = OrdBy;
exports.$$Set = $$Set;
exports.SetWithNone = SetWithNone;
exports.$$Map = $$Map;
exports.list = list;
exports.array = array;
exports.set = set;
exports.setWithNone = setWithNone;
exports.cardinality = cardinality;
exports.top = top;
exports.bottom = bottom;
exports.succ = succ;
exports.pred = pred;
exports.toString = toString;
exports.fromString = fromString;
exports.fromInt = fromInt;
exports.decode = decode;
exports.encode = encode;
/* include Not a pure module */
